import axios from "@/axios-auth";
import router from "@/router";

const namespaced = true;

const state = {
  firstName: "",
  lastName: "",
  email: "",
  loggedIn: false,
  token: ""
};
const getters = {
  getFullName: state => `${state.firstName} ${state.lastName}`,
  getEmail: state => state.email,
  getLoggedIn: state => state.loggedIn,
  getToken: state => state.token
};
const mutations = {
  setFirstName: (state, payload) => {
    state.firstName = payload;
  },
  setLastName: (state, payload) => {
    state.lastName = payload;
  },
  setEmail: (state, payload) => {
    state.email = payload;
  },
  setLoggedIn: (state, payload) => {
    state.loggedIn = payload;
  },
  setToken: (state, payload) => {
    state.token = payload;
  }
};
const actions = {
  clearData: (context) => {
    context.commit("setLoggedIn", false);
    context.commit("setFirstName", "");
    context.commit("setLastName", "");
    context.commit("setEmail", "");
    context.commit("setToken", "");
    localStorage.removeItem("token");
  },
  // regular login using email & password
  login: (context, payload) => new Promise((resolve, reject) => {
    axios.post("/users/login", payload)
      .then((response) => {
        context.commit("setLoggedIn", true);
        context.commit("setFirstName", response.data.firstName);
        context.commit("setLastName", response.data.lastName);
        context.commit("setEmail", response.data.email);
        context.commit("setToken", response.headers["x-auth"]);
        localStorage.setItem("token", response.headers["x-auth"]);
        resolve(true);
      })
      .catch((error) => {
        context.dispatch("clearData");
        router.push("/login");
        reject(error);
      });
  }),
  // auto login using token
  autoLogin: context => new Promise((resolve, reject) => {
    context.commit("setToken", localStorage.getItem("token"));
    axios.get("/users/me", { headers: { "x-auth": context.getters.getToken } })
      .then((response) => {
        context.commit("setLoggedIn", true);
        context.commit("setFirstName", response.data.firstName);
        context.commit("setLastName", response.data.lastName);
        context.commit("setEmail", response.data.email);
        context.commit("setToken", response.headers["x-auth"]);
        localStorage.setItem("token", response.headers["x-auth"]);
        resolve(true);
      })
      .catch((error) => {
        context.dispatch("clearData");
        router.push("/login");
        reject(error);
      });
  }),
  logout: context => new Promise((resolve, reject) => {
    context.commit("setToken", localStorage.getItem("token"));
    axios.delete("/users/me/token", { headers: { "x-auth": context.getters.getToken } })
      .then(() => {
        context.dispatch("clearData");
        router.push("/login");
        resolve(true);
      })
      .catch((error) => {
        context.dispatch("clearData");
        router.push("/login");
        reject(error);
      });
  })
};

export default {
  namespaced,
  state,
  getters,
  mutations,
  actions
};
